import React from "react";
import { createRoot } from "react-dom/client";

// import reportWebVitals from "./reportWebVitals";

const FileList = React.lazy(() => import(/* webpackChunkName: "FL" */ "FileList/FileList.jsx"));
const FAQ = React.lazy(() => import(/* webpackChunkName: "F" */ "FAQ/FAQ.jsx"));
const Parkings = React.lazy(() => import(/* webpackChunkName: "P" */ "Parkings/Parkings.jsx"));
const Assos = React.lazy(() => import(/* webpackChunkName: "A" */ "Associations/Associations.jsx"));
const EncartAgenda = React.lazy(() => import(/* webpackChunkName: "EA" */ "EncartAgenda/EncartAgenda.jsx"));
const ActivitesMap = React.lazy(() => import(/* webpackChunkName: "AM" */ "Associations/ActivitesMap.jsx"));
const FicheAssociation = React.lazy(() => import(/* webpackChunkName: "FA" */ "Associations/Fiche.jsx"));
const AssociationsActivites = React.lazy(() => import(/* webpackChunkName: "AL" */ "Associations/ActivitesListe.jsx"));
const Carousel = React.lazy(() => import(/* webpackChunkName: "CA" */ "Carousel/CarouselActu.jsx"));
const SearchBar = React.lazy(() => import(/* webpackChunkName: "SB" */ "SearchBar/SearchBar.jsx"));

function hookElements(className, Element) {
  var list = document.getElementsByClassName(className);
  for (var i = 0; i < list.length; i++) {
    var props = {};
    var atts = list[i].attributes;

    for (var j = 0; j < atts.length; j++) {
      if (atts[j].nodeName !== "class") props[atts[j].nodeName] = atts[j].nodeValue;
    }
    const root = createRoot(list[i]);

    root.render(<Element {...props} />);
  }
}

hookElements("file_list", FileList);
hookElements("faq", FAQ);
hookElements("parkings", Parkings);
hookElements("associations", Assos);
hookElements("associations_activites", ActivitesMap);
hookElements("fiche_association", FicheAssociation);
hookElements("encart_agenda", EncartAgenda);
hookElements("associations_activites_liste", AssociationsActivites);
hookElements("carousel_actu", Carousel);
hookElements("search_bar", SearchBar);

// reportWebVitals(console.log);
